"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = ["header[_ngcontent-%COMP%]{background:0 0/contain #2196f3;color:#fff;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-direction:row-reverse;flex-direction:row-reverse;padding:0 15px;z-index:0;box-shadow:0 0 2px rgba(0,0,0,.3);-ms-flex-positive:0;flex-grow:0}header[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{margin:10px 0}header[_ngcontent-%COMP%]   .close-btn[_ngcontent-%COMP%]{cursor:pointer;margin-top:14px}"];
exports.styles = styles;
